import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../state/context";

import ReactQuill, {Quill} from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { ROLE } from '../../enums/roles';
import { hasRole } from '../../utils/hasRole';

let Inline = Quill.import('blots/inline');

class BoldBlot extends Inline { }
BoldBlot.blotName = 'bold';
BoldBlot.tagName = 'b';
Quill.register('formats/bold', BoldBlot);

const formats = ["bold", "italic", "underline", "link"];
const modules = {
    toolbar: [
        ["bold", "italic", "underline", "link"],
    ]
};

export default function TranslationItemDetails({ label, originalText, text, handleSubmit }) {
    const { state } = useContext(Context);
    const [roles, setRoles] = useState([]);
    const [localText, setLocalText] = useState(originalText || "");
    const [displaySave, setDisplaySave] = useState(false);

    useEffect(() => {
        setRoles(state.roles);
    }, [state.roles]);

    useEffect(() => {
        setLocalText(originalText);
    }, [originalText]);

    useEffect(() => {
        setDisplaySave(localText !== originalText);
    }, [localText]);

    const handleSave = () => {
        handleSubmit(localText);
        setDisplaySave(false);
    }

    return (
        <div>
            {(originalText && !hasRole(roles, ROLE.ADMIN)) ?
                <div className="mb-4">
                    <h6 className="translation-section-title text-muted">{label}</h6>
                    <p className={"card-text"} dangerouslySetInnerHTML={{ __html: text }} />
                </div> : ""}

            {hasRole(roles, ROLE.ADMIN) &&
                <div className="mb-4">
                    <h6 className="translation-section-title text-muted">{label}</h6>
                    <div className={"form-group"}>
                        <ReactQuill 
                            theme="snow" 
                            defaultValue={localText ? localText.replace(/(\n)/g, '<br/>') : ""} 
                            value={localText ? localText.replace(/(\n)/g, '<br/>') : ""} 
                            placeholder={"Add indications here"} 
                            rows={3} 
                            modules={modules} 
                            formats={formats}
                            onChange={setLocalText}/>
                        <button className={`btn btn-mondly btn-blue mt-2 mb-0${displaySave ? '' : ' transparent'}`} disabled={!displaySave} onClick={handleSave}>Save</button>
                    </div>
                </div>}
        </div>
    )

}
